/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "auth",
            "endpoint": "https://ho6oizvc6b.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "brief",
            "endpoint": "https://6qmpex7iyf.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "briefAsync",
            "endpoint": "https://wu92kwjhs9.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "crawler",
            "endpoint": "https://jexkoxcscl.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "plans",
            "endpoint": "https://2lx0k10h18.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "projects",
            "endpoint": "https://wbocfibijb.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "public",
            "endpoint": "https://asiophwhde.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "seoMissions",
            "endpoint": "https://9b4dgdwv9e.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "serps",
            "endpoint": "https://6xz88lr8wj.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "suggestions",
            "endpoint": "https://6qu3hkkvxi.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "users",
            "endpoint": "https://9160i18j2a.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "utils",
            "endpoint": "https://207mif04z5.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "webhooks",
            "endpoint": "https://ohbi49zyl3.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:9be2299b-02b7-412e-8972-2352f5f4fa6d",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_tj0QH3mcU",
    "aws_user_pools_web_client_id": "o2vog2so66qbjsb60ni4qao2u",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "crawler-production",
            "region": "eu-central-1"
        },
        {
            "tableName": "jobs-production",
            "region": "eu-central-1"
        },
        {
            "tableName": "plans-production",
            "region": "eu-central-1"
        },
        {
            "tableName": "projects-production",
            "region": "eu-central-1"
        },
        {
            "tableName": "briefs-production",
            "region": "eu-central-1"
        },
        {
            "tableName": "serps-production",
            "region": "eu-central-1"
        },
        {
            "tableName": "storage-production",
            "region": "eu-central-1"
        },
        {
            "tableName": "suggestions-production",
            "region": "eu-central-1"
        },
        {
            "tableName": "users-production",
            "region": "eu-central-1"
        }
    ]
};


export default awsmobile;
